import PersonalInfoPageContent from '@/components/PersonalInfoPageContent';
import { useStaffMemberInfoContext } from '../StaffMemberInfo/StaffMemberInfo.context';

const StaffMemberResume = (): JSX.Element => {
  const { staffMember, refreshUser } = useStaffMemberInfoContext();

  return (
    <PersonalInfoPageContent
      person={staffMember?.person}
      onUpdateUser={refreshUser}
      toastSuccessText="The staff member information has been updated."
    />
  );
};

export default StaffMemberResume;
